import { inject } from '@angular/core';
import {
  setError,
  withCallState,
} from '@kinet-open-network/client/shared/data-access/state';
import { callApiMethod } from '@kinet-open-network/client/shared/util';
import { IUserEmailSettings } from '@kinet-open-network/shared/data-access/model';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { UserEmailSettingsService } from '../services/user-email-settings.service';

interface UserEmailSettingsState {
  model: IUserEmailSettings | null;
}

export const UserEmailSettingsStore = signalStore(
  withState<UserEmailSettingsState>({ model: null }),
  withCallState(),
  withMethods((store, service = inject(UserEmailSettingsService)) => ({
    loadSettings: () =>
      callApiMethod(() => service.getNotificationsSettings(), {
        next: (settings) => patchState(store, { model: settings }),
        error: (err) => patchState(store, setError(err)),
      }),
    updateSettings: (data: Partial<IUserEmailSettings>) =>
      callApiMethod(() => service.updateNotificationsSettings(data), {
        next: (settings) => patchState(store, { model: settings }),
        error: (err) => patchState(store, setError(err)),
      }),
  })),
);
